"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M9 5a1 1 0 11-2 0 1 1 0 012 0zM5 7c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H5zm3 5a1 1 0 100-2 1 1 0 000 2z"];
//# sourceMappingURL=divide.js.map